import { Link } from 'react-router-dom';

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-[#0a0a14] text-gray-300">
      <nav className="border-b border-purple-900/30 bg-[#0d0d18]">
        <div className="max-w-4xl mx-auto px-4 md:px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/ac6eabdb4cc8c584e68459ed2e8db63e/795a02a9e33dcc555b6c719772e4793b.png"
              alt="Roblox Secrets"
              className="h-8 w-8 object-contain"
            />
            <span className="font-black text-yellow-400 text-base uppercase tracking-widest" style={{ textShadow: '0 0 10px rgba(250,204,21,0.4)' }}>
              Roblox Secrets
            </span>
          </Link>
          <Link to="/" className="text-sm text-gray-400 hover:text-yellow-400 transition-colors duration-200 flex items-center gap-1.5 cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-line"></i>
            Back to Home
          </Link>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="mb-10">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-yellow-400 bg-yellow-400/10 px-3 py-1 rounded-full mb-4">Legal</span>
          <h1 className="text-3xl md:text-4xl font-black text-white mb-3">Cookie Policy</h1>
          <p className="text-gray-500 text-sm">Last updated: April 6, 2026</p>
        </div>

        <div className="space-y-6">
          <Section title="What Are Cookies?">
            <p className="text-gray-400 leading-relaxed">
              Cookies are small text files stored on your device when you visit a website. They help the website remember your preferences and improve your experience.
            </p>
          </Section>

          <Section title="How We Use Cookies">
            <p className="text-gray-400 leading-relaxed">
              This website uses cookies to improve user experience. Cookies help us understand how visitors use the site so we can make it better.
            </p>
          </Section>

          <Section title="Your Consent">
            <p className="text-gray-400 leading-relaxed">
              By using this website, you agree to the use of cookies as described in this policy.
            </p>
          </Section>

          <Section title="Managing Cookies">
            <p className="text-gray-400 leading-relaxed">
              You can disable cookies in your browser settings if you prefer. Please note that disabling cookies may affect the functionality of some parts of the website.
            </p>
          </Section>

          <Section title="Contact">
            <p className="text-gray-400 leading-relaxed">
              If you have any questions about our Cookie Policy, contact us at:{' '}
              <a href="mailto:thekids@robloxsecrets.pro" className="text-yellow-400 hover:underline cursor-pointer">
                thekids@robloxsecrets.pro
              </a>
            </p>
          </Section>
        </div>

        <LegalNav current="cookie" />
      </main>

      <LegalFooter />
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="bg-[#0d0d18] border border-purple-900/30 rounded-lg p-6">
      <h2 className="text-white font-black text-lg mb-4 flex items-center gap-2">
        <span className="w-1 h-5 bg-yellow-400 rounded-full inline-block"></span>
        {title}
      </h2>
      {children}
    </div>
  );
}

function LegalNav({ current }: { current: string }) {
  const pages = [
    { label: 'Privacy Policy', href: '/privacy-policy', id: 'privacy' },
    { label: 'Terms of Service', href: '/terms', id: 'terms' },
    { label: 'Refund Policy', href: '/refund-policy', id: 'refund' },
    { label: 'Cookie Policy', href: '/cookie-policy', id: 'cookie' },
  ];
  return (
    <div className="mt-12 pt-8 border-t border-purple-900/30">
      <p className="text-gray-500 text-xs uppercase tracking-widest mb-4">Other Legal Pages</p>
      <div className="flex flex-wrap gap-3">
        {pages.filter(p => p.id !== current).map(p => (
          <Link
            key={p.id}
            to={p.href}
            className="text-sm text-gray-400 hover:text-yellow-400 border border-purple-900/40 hover:border-yellow-400/40 px-4 py-2 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            {p.label}
          </Link>
        ))}
      </div>
    </div>
  );
}

function LegalFooter() {
  return (
    <footer className="border-t border-purple-900/30 bg-[#0d0d18] mt-8">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-gray-600 text-sm">&copy; {new Date().getFullYear()} Roblox Secrets. All rights reserved.</p>
        <p className="text-gray-700 text-xs text-center">Not affiliated with Roblox Corporation.</p>
      </div>
    </footer>
  );
}
